import Home from "@/modules/home/pages/Home.vue";
import Dashboard from "@/modules/home/pages/Dashboard.vue";
import Integration from "@/modules/integration/pages/Integrations.vue";
import Customization from "@/modules/customization/routes";
import Applicants from "@/modules/applicants/routes";
// Please see link below for import .vue caveat
//https://github.com/vuejs/vue-router/issues/713#issuecomment-341100805
import BusinessDashboard from "@/modules/businesses/pages/BusinessDashboard.vue";
import Businesses from "@/modules/businesses/routes";

export default [
  {
    path: "/home",
    component: Home,
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "",
        name: "dashboard",
        component: Dashboard,
        children: [...Applicants],
        meta: {
          authRequired: true,
        },
      },
      {
        path: "business-dashboard",
        name: "business-dashboard",
        component: BusinessDashboard,
        children: [...Businesses],
        meta: {
          authRequired: true,
        },
      },
      {
        path: "integration",
        name: "integration",
        component: Integration,
        meta: {
          authRequired: true,
          isAdmin: true,
          allowDevelopers: true,
        },
      },
      ...Customization,
    ],
  },
];
